// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Notification State
// -------------------------------
export interface NotificationState extends EntityState<any> {
  common?: any;
}

// -------------------------------
//  Notification Adapter
// -------------------------------
export const businessAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Notification Initial State
// -------------------------------
export const initialState: NotificationState = businessAdapter.getInitialState(
  {
    common: null,

  },
);
